import { storyblokInit } from "@storyblok/react";

storyblokInit({
  bridge: true,
});
